import './ConnectivityStatus.scss';

export { default } from './ConnectivityStatus';
